<template>
  <div id="app"
       :style="{'--panel-box-shadow-color': $store.getters.getPanelBoxShadowColor, '--text-color': $store.getters.getTextColor}">
    <main v-if="is_theme_loaded">
      <div class="container" v-if="logo">
        <div style="margin-top: 10px;">
          <div class="col-md-12 text-center">
            <div class="col-md-12 visible-md visible-lg" style="margin-top:10px;margin-bottom:10px;max-height:120px;">
              <img v-bind:src="backend_url + logo" class="img-logo">
            </div>
            <div class="col-md-12 visible-xs visible-sm" style="margin-top:10px;margin-bottom:10px;">
              <img class="img-logo"
                    v-bind:src="backend_url + logo">
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <app-view></app-view>
      </div>
    </main>
    <main v-if="!is_theme_loaded">
      <div class="container">
        <spinner></spinner>
      </div>
    </main>
  </div>
</template>

<script>

import Spinner from './components/ui/Spinner';
import { Settings } from 'luxon'

export default {

  name: 'App',
  data() {
    return {
      is_theme_loaded: false,
      logo: false,
      backend_url: false,
      isLoading: false,
      fullPage: true
    }
  },
  mounted() {

    this.backend_url = process.env.VUE_APP_BACKEND_URL;

    let aclUid = 0;

    if (this.$route.params.uid) {
      aclUid = this.$route.params.uid;
    }

    this.$store.dispatch('LOAD_THEME', aclUid).then((resp) => {
      // body
      let background_color = this.$store.getters.getBackgroundColor;
      let body = document.querySelector('body');
      body.style.backgroundColor = background_color;

      // buttons

      this.is_theme_loaded = true;

      body.style.display = '';

      this.logo = this.$store.getters.getLogoPath;

      const data = resp.data;

      this.$i18n.locale = data.defaultLanguage;

      Settings.defaultLocale = this.$t("ui.luxonCode");

      if(data.theme.custom_js) {
        try {
          eval(data.theme.custom_js);
        } catch(Exception) {
          console.log('Exception when execute custom JS. Skip');
        }
      }

    }).catch(() => {
      /*this.$swal("Error", "The server is temporary down", "error", 'Retry').then(() => {
          window.location.reload();
      });*/
      this.$swal({
        title: 'Error',
        text: 'The server is temporary down',
        icon: 'error',
        confirmButtonColor: this.$store.getters.getButtonColor,
        confirmButtonText: 'Retry'
      }).then(() => {
        window.location.reload();
      });
    });

    this.$store.dispatch('GENERATE_BROWSER_UID');
  },
  components: {
    Spinner
  },
  /*metaInfo() {

    let og_image = window.location.origin + '/favicon.ico'

    if (this.logo) {
      og_image = process.env.VUE_APP_BACKEND_URL + this.logo
    }

    return {
      title: `Survey`,
      meta: [
        {name: 'description', content: 'Survey'},
        {property: 'og:title', content: 'Survey'},
        {property: 'og:site_name', content: 'Survey'},
        {property: 'og:description', content: 'Survey'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: window.location.origin},
        {property: 'og:image', content: og_image},
        {property: 'twitter:card', content: 'summary_large_image'},
        {property: 'twitter:url', content: window.location.origin},
        {property: 'twitter:title', content: 'Survey'},
        {property: 'twitter:description', content: 'Survey'},
        {property: 'twitter:image', content: og_image}
      ]
    }
  },*/
}
</script>

<style>

</style>
